import { render, staticRenderFns } from "./assignment.html?vue&type=template&id=1ae92c64&scoped=true&"
import script from "./assignment.js?vue&type=script&lang=js&"
export * from "./assignment.js?vue&type=script&lang=js&"
import style0 from "./assignment.css?vue&type=style&index=0&id=1ae92c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae92c64",
  null
  
)

export default component.exports